export const FAMILY_META = {
  INTENT: { label: 'Intent', className: 'badge-intent' },
  CAPACITY: { label: 'Capacity', className: 'badge-capacity' },
  ACTIVITY: { label: 'Activity', className: 'badge-activity' },
  ORG_CHANGE: { label: 'Org change', className: 'badge-org-change' },
};

export function familyLabel(family) {
  return FAMILY_META[family]?.label || family || 'Unattributed';
}

export function familyClassName(family) {
  return FAMILY_META[family]?.className || 'badge-default';
}

/**
 * The real-world date a signal happened (job posted, filing published, paper
 * released). Every connector's normalizer sets `observed_at` to the moment
 * we scraped it (see the backend's per-domain normalizer.py files) — it is
 * NOT the event date and must never be treated as one. `published_at` is
 * the true event date when the source provides it (funding/research
 * usually do; hiring usually doesn't). Fall back to `observed_at` only when
 * `published_at` is missing, and say so — never claim it's the event date.
 */
export function eventDate(sig) {
  return sig.published_at || sig.observed_at;
}

export function isEventDateEstimated(sig) {
  return !sig.published_at;
}

export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function preciseTimeAgo(iso) {
  if (!iso) return '—';
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 5) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return timeAgo(iso);
}

export function timeAgo(iso) {
  if (!iso) return '—';
  const days = Math.round((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days <= 0) return 'today';
  if (days === 1) return '1 day ago';
  if (days < 30) return `${days} days ago`;
  return `${Math.round(days / 30)} mo ago`;
}
